import GameConfig from "../core/data/GameConfig";
import { GameObject } from "../core/GameObject";
import GameColors from "../GameColors";
import PlayerData from "../PlayerData";
import { GameScene } from "../scenes/GameScene";
import Fonts from "../utils/Fonts";
import LaunchMeter from "./LaunchMeter";
import { ProgressMeter } from "./ProgressMeter";
import { SlamMeter } from "./SlamMeter";

export class GameUI extends GameObject {
	slamMeter: SlamMeter;
	progressMeter: ProgressMeter;
	scene: GameScene;
	coinsAmount: Phaser.GameObjects.Text;
	distanceAmount: Phaser.GameObjects.Text;
	launchMeter: LaunchMeter;
	leftGroup: Phaser.GameObjects.Container;
	rightGroup: Phaser.GameObjects.Container;
	distanceTXT: Phaser.GameObjects.Text;
	coinsText: Phaser.GameObjects.Text;
	distanceBG: Phaser.GameObjects.Image;
	missionGroup: Phaser.GameObjects.Container;
	missionText: Phaser.GameObjects.Text;
	missionIcon: Phaser.GameObjects.Image;
	coinsGroup: Phaser.GameObjects.Container;
	glowContainer: Phaser.GameObjects.Container;
	velocityDebug: Phaser.GameObjects.Text;
	missionBG: Phaser.GameObjects.Image;

	constructor(scene: GameScene) {
		super(scene);
		this.scene = scene;

		const leftGroup = this.leftGroup = scene.add.container();
		const rightGroup = this.rightGroup = scene.add.container();
		this.add([leftGroup, rightGroup]);
		const slamMeter = this.slamMeter = new SlamMeter(scene);
		leftGroup.add(slamMeter);

		const progressMeter = this.progressMeter = new ProgressMeter(scene);
		rightGroup.add(progressMeter);

		const pauseBtn = scene.add.button(0, 0, "pauseButton" + (this.scene.game.device.os.desktop ? "" : "Mobile"), undefined, this.showPauseScreen, this, true);
		this.add(pauseBtn);

		const coinsGroup = this.coinsGroup = scene.add.container();
		leftGroup.add(coinsGroup);
		const coinsBG = this.addImage("hudBacker");
		coinsGroup.add(coinsBG);
		coinsGroup.setSize(coinsBG.width, coinsBG.height);

		const distanceGroup = scene.add.container();
		leftGroup.add(distanceGroup);
		const distanceBG = this.distanceBG = this.addImage("hudBacker");
		distanceGroup.add(distanceBG)
		distanceGroup.setSize(distanceBG.width, distanceBG.height);

		const coin = this.addImage("missionCoin").setScale(0.65);
		coinsGroup.add(coin);
		const boot = this.addImage("distanceIcon");
		distanceGroup.add(boot);

		const coinsText = this.coinsText = scene.add.text(0, 0, "x", {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "24px",
		});
		coinsGroup.add(coinsText);
		const distanceText = this.distanceTXT = scene.add.text(0, 0, "m", {
			fontFamily: Fonts.DefaultFont,
			color: GameColors.WHITE,
			fontSize: "28px",
		});
		distanceGroup.add(distanceText);

		const coinsAmount = this.coinsAmount = scene.add.text(0, 0, "0", {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "32px",
		});
		coinsGroup.add(coinsAmount);
		const distanceAmount = this.distanceAmount = scene.add.text(0, 0, "0", {
			fontFamily: Fonts.LuckiestGuy,
			color: GameColors.WHITE,
			fontSize: "32px",
		});
		distanceGroup.add(distanceAmount);

		const missionGroup = this.missionGroup = scene.add.container();
		this.add(missionGroup);
		const missionBG = this.missionBG = this.addImage("hudMissionBG");
		missionBG.setScale(1.35);
		const missionIcon = this.missionIcon = this.addImage("hudMissionCheck");
		missionIcon.setScale(1.35);
		const missionText = this.missionText = scene.add.text(0, 0, "Test Text Goes Here!", {
			fontFamily: Fonts.MaliBoldItalic,
			color: GameColors.WHITE,
			fontSize: "26px",
			align: "left"
		});
		missionGroup.add([missionBG, missionIcon, missionText]);
		missionGroup.setSize(missionBG.displayWidth, missionBG.displayHeight);
		missionGroup.setAlpha(0);
		
		const launchMeter = this.launchMeter = new LaunchMeter(scene);
		this.add(launchMeter);

		this.glowContainer = scene.add.container();
		this.add(this.glowContainer);
		const rightGlow = this.addImage("hudHitGlow");
		const leftGlow = this.addImage("hudHitGlow");
		leftGlow.setFlipX(true);
		this.glowContainer.add([rightGlow, leftGlow]);
		this.glowContainer.setAlpha(0);

		const velocityDebug = this.velocityDebug = scene.add.text(0, 0, "0000", {
			fontFamily: Fonts.DefaultFont,
			color: GameColors.ORANGE,
			stroke: GameColors.BLACK,
			strokeThickness: 6,
			fontSize: "64px",
			align: "right",
		});
		this.add(velocityDebug);
		velocityDebug.originX = 1;
		velocityDebug.visible = GameConfig.get<boolean>("velocityDebug");
		scene.alignIn.BottomCenter(launchMeter, scene.viewport, 0, launchMeter.height + 50);
		scene.addResize(() => {
			this.setSize(scene.viewport.width, scene.viewport.height);
			let scale = Math.min(scene.viewport.width/1920, 1);
			scale = Math.max(scale, 0.85);

			slamMeter.scale = scale;
			progressMeter.scale = scale;
			coinsGroup.scale = scale;
			distanceGroup.scale = scale;

			scene.alignIn.TopLeft(pauseBtn, scene.viewport, -34, -34);
			scene.alignIn.TopLeft(slamMeter, scene.viewport, -34, -164 + (slamMeter.height - slamMeter.displayHeight) / 2 - (slamMeter.slots.length > 6 ? 60 : 0));
			scene.alignIn.BottomCenter(progressMeter, scene.viewport, 0, -24 + (coinsGroup.height - coinsGroup.displayHeight));
			scene.alignIn.BottomLeft(coinsGroup, scene.viewport, -34 + (coinsGroup.width - coinsGroup.displayWidth), -23 + (coinsGroup.height - coinsGroup.displayHeight));
			scene.alignTo.RightCenter(distanceGroup, coinsGroup, 10 - (distanceGroup.width - distanceGroup.displayWidth), 0);
			launchMeter.x = scene.viewport.width/2;
			scene.alignIn.LeftCenter(coin, coinsBG, 0, 0);
			scene.alignIn.LeftCenter(coinsText, coinsBG, -56, 0);
			scene.alignIn.LeftCenter(boot, distanceBG, -10, 0);
			scene.alignTo.RightCenter(coinsAmount, coinsText, 6, -3);
			scene.alignIn.LeftCenter(distanceAmount, distanceBG, -60, -2);
			scene.alignIn.RightCenter(distanceText, distanceAmount, 40, 0);

			missionGroup.scale = scale;
			scene.alignIn.TopCenter(missionGroup, scene.viewport, 0, -23);
			scene.alignIn.LeftCenter(missionIcon, missionBG, 70, 0);
			scene.alignTo.RightCenter(missionText, missionIcon, 32, 0);

			rightGlow.scale = scene.viewport.height / rightGlow.height;
			leftGlow.scale = rightGlow.scale;
			scene.alignIn.LeftCenter(leftGlow, scene.viewport, (leftGlow.displayWidth - leftGlow.width) / 2, 0);
			scene.alignIn.RightCenter(rightGlow, scene.viewport, (rightGlow.displayWidth - rightGlow.width) / 2, 0);

			scene.alignIn.TopCenter(velocityDebug, scene.viewport, 0, -50);
		});

		this.hideUI();
	}

	update(dt: number): void {
		this.launchMeter.update(dt);
		super.update(dt);
		if (this.velocityDebug.visible) {
			const player = this.scene.ltGame.player;
			const vel = player.planckBody.velocity;
			this.velocityDebug.setText(`VX: ${Math.round(vel.x)}\nVY: ${Math.round(vel.y)}\nBounce: ${Math.round(player.bounceSpeed)}`);
		}
	}

	hideUI(): void {
		this.leftGroup.x = -500;
		this.rightGroup.y = 300;
	}

	tweenUI(): void {
		this.scene.tweens.add({
			targets: this.leftGroup,
			x: 0,
			duration: 500,
			ease: Phaser.Math.Easing.Quadratic.Out,
			onComplete: () => {
				this.slamMeter.playAddSlamAnim()
			}
		});

		this.scene.tweens.add({
			targets: this.rightGroup,
			y: 0,
			duration: 1000,
			delay: 500,
			ease: Phaser.Math.Easing.Quadratic.Out,
		});

		this.launchMeter.tweenUI();

		// this.playMissionNotification("Test text 123456789!")
	}

	updateSlamMeter(amt: number): void {
		this.slamMeter.setProgress(amt);
	}

	useSlam(slams: number): void {
		this.slamMeter.useSlam(slams);
	}

	slamFail(): void {
		this.slamMeter.slamFail();
	}

	updateCoins(amt: number): void {
		const amount = amt.toLocaleString("en-US");
		this.coinsAmount.setText(amount + "");
		this.scene.alignTo.RightCenter(this.coinsAmount, this.coinsText, 6, -3);
	}

	updateDistance(amt: number): void {
		if(amt < 0) amt = 0;
		const distance = amt.toLocaleString("en-US");
		const str = distance + "";
		const prevLength = this.distanceAmount.text.length;
		if (str != this.distanceAmount.text) {
			this.distanceAmount.setText(distance + "");
			this.scene.alignIn.LeftCenter(this.distanceAmount, this.distanceBG, -60, -2);
			if(str.length != prevLength) this.scene.alignTo.RightCenter(this.distanceTXT, this.distanceAmount, 1, 4);
		}
	}

	playMissionNotification(text: string): void {
		this.scene.tweens.killTweensOf(this.missionGroup);
		this.missionGroup.y -= 300;
		this.missionGroup.alpha = 1;
		this.missionText.setText(text);
		const ogWidth = this.missionBG.displayWidth;
		let adjust = 0;
		if (this.missionText.displayWidth > this.missionGroup.displayWidth * 0.8) {
			// console.log("Adjust mission popup");
			const newWidth = this.missionBG.displayWidth * (this.missionText.displayWidth / (this.missionGroup.displayWidth * 0.8));
			adjust = (newWidth - this.missionBG.displayWidth) / 2;
			this.missionBG.displayWidth = newWidth;
			this.missionBG.x += adjust;
			this.missionGroup.x -= adjust;
		} 
		this.scene.alignTo.RightCenter(this.missionText, this.missionIcon, 32, 0);
		this.scene.tweens.add({
			targets: this.missionGroup,
			y: this.missionGroup.y + 300,
			duration: 1000,
			ease: Phaser.Math.Easing.Quadratic.In,
			onComplete: () => {
				this.scene.tweens.add({
					targets: this.missionGroup,
					alpha: 0,
					ease: Phaser.Math.Easing.Quadratic.Out,
					delay: 3000,
					duration: 500,
					onComplete: () => {
						this.missionBG.displayWidth = ogWidth;
						this.missionBG.x -= adjust;
						this.missionGroup.x += adjust;
					}
				});
			}
		});
	}

	updateProgress(amt: number): void {
		this.progressMeter.setProgress(amt);
	}

	showPauseScreen(): void {
		this.scene.pause();
	}

	playHitGlow(): void {
		this.scene.tweens.killTweensOf(this.glowContainer);
		this.glowContainer.setAlpha(1);
		this.scene.tweens.add({
			targets: this.glowContainer,
			alpha: 0,
			duration: 800,
			ease: Phaser.Math.Easing.Quadratic.In,
		})
	}
}